import React from 'react';
import { useTranslation } from 'react-i18next';
import AntdCustomButton from '../../../../components/buttons/AntdCustomButton';

interface SidebarActionsProps {
  onReset?: () => void;
  onClose: () => void;
  showReset?: boolean;
}

const SidebarActions: React.FC<SidebarActionsProps> = ({
  onReset,
  onClose,
  showReset = true
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2 mt-[24px]">
      <AntdCustomButton className='flex-1' onClick={onClose} appearance="important">
        {t('Close')}
      </AntdCustomButton>
      {showReset && onReset && (
        <AntdCustomButton onClick={onReset} appearance="default">
          {t('Reset')}
        </AntdCustomButton>
      )}
    </div>
  );
};

export default SidebarActions;
